import React, { useState } from 'react';

import {
  Container,
  Text,
  AccordionWrapper,
  Accordion,
  AccordionHeader,
  AccordionBody,
  Icon,
  TextWrapper,
  BottomDiv,
  Link,
} from './styles';

import { faq } from '../../../static/data/faq.json';
import ChevronActive from '../../../static/icons/chevron-active.svg';
import ChevronInactive from '../../../static/icons/chevron-inactive.svg';
import PDFSlide from '../../../static/docs/criterios_precatorios.pdf';

function FaqSection() {
  const [visibleItem, setVisibleItem] = useState(null);
  const lastItemIndex = faq.length + 1;
  const lastItemVisible = lastItemIndex === visibleItem;

  const handleClick = itemId => {
    setVisibleItem(currentItem => (currentItem === itemId ? null : itemId));
  };

  return (
    <Container>
      <TextWrapper>
        <Text>
          <b>FAQ</b> - PERGUNTAS MAIS FREQUENTES
        </Text>
      </TextWrapper>
      <AccordionWrapper>
        {faq.map((item, index) => {
          const visible = visibleItem === index;

          return (
            <Accordion key={item.header} onClick={() => handleClick(index)}>
              <AccordionHeader visible={visible}>
                {item.header}
                <Icon
                  src={visible ? ChevronActive : ChevronInactive}
                  visible={visible}
                />
              </AccordionHeader>
              <AccordionBody visible={visible}>{item.body}</AccordionBody>
            </Accordion>
          );
        })}

        <Accordion onClick={() => handleClick(lastItemIndex)}>
          <AccordionHeader visible={lastItemVisible}>
            Quais precatórios são elegíveis para a compra da Precatórios Brasil?
            <Icon
              src={lastItemVisible ? ChevronActive : ChevronInactive}
              visible={lastItemVisible}
            />
          </AccordionHeader>
          <AccordionBody visible={lastItemVisible}>
            <Link
              href={PDFSlide}
              download="criterios_precatorios.pdf"
              title="Clique para saber mais sobre os critérios de compra."
            >
              Clique <b>aqui</b> para saber os nossos critérios de compra!
            </Link>
          </AccordionBody>
        </Accordion>
      </AccordionWrapper>
      <BottomDiv />
    </Container>
  );
}

export default FaqSection;
